import React from "react";
import styled from "styled-components";
import { ProxiedRoutes } from "@lifeat/shared/system/RouteConstants";
import { LifeAtButtonV2 } from "@common/LifeAtButtonV2/LifeAtButtonV2";
import { BrowserUtil } from "@util/index";
import DownloadIcon from "/resources/icons/DownloadIcon.svg";

const StyledDownloadIcon = styled(DownloadIcon)`
    fill: ${(props) => props.theme.iconColor};
`;

const DESKTOP_APP_BUTTON_LABEL = "Desktop App";
interface DesktopAppButtonProps {}
export default function DesktopAppButton(props: DesktopAppButtonProps) {
    return (
        <LifeAtButtonV2
            onClick={() => BrowserUtil.openLinkNewTab(ProxiedRoutes.Download)}
            size={"small"}
            disableHover={true}
        >
            <StyledDownloadIcon />
            {DESKTOP_APP_BUTTON_LABEL}
        </LifeAtButtonV2>
    );
}
